import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '@env/environment'
import { Observable, map } from 'rxjs'

@Injectable()
export class WebsocketAuthCommand {
  constructor(private httpClient: HttpClient) {}

  call(): Observable<string> {
    const url = `${environment.api.app}/websockets_auth/sessions`
    const params = {}

    return this.httpClient.post<string>(url, params).pipe(map((response: any) => response.token))
  }
}
